export const ADD_VARIATIONS = 'ADD_VARIATIONS'
export const ADD_VARIATION = 'ADD_VARIATION'
